/** 4-digit numeric PIN input. */
export default function PinInput({ id, value, onChange, invalid, disabled }) {
  return (
    <input
      id={id}
      type="password"
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={4}
      value={value}
      disabled={disabled}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
        onChange(digits);
      }}
      placeholder="----"
      className={`ck-input ck-pin ${invalid ? 'ck-input--invalid' : ''}`}
    />
  );
}

export function FieldError({ message }) {
  return (
    <div className="ck-field-error">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M12 8v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.5" r="1" fill="currentColor" />
      </svg>
      <span>{message}</span>
    </div>
  );
}

